import { render, staticRenderFns } from "./TrunkTrajectoryGeometry.vue?vue&type=template&id=6f8c1419&"
import script from "./TrunkTrajectoryGeometry.vue?vue&type=script&lang=js&"
export * from "./TrunkTrajectoryGeometry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports